import { Stack, Typography } from '@mui/material';

export const ErrorOverlay = () => {
  return (
    <Stack
      display={'flex'}
      height={'100%'}
      width={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={'1rem'}
    >
      <Typography fontSize={'1rem'} fontWeight={600}>
        No Data
      </Typography>
      <Typography fontSize={'0.875'} fontWeight={400}>
        Fruit size is unavailable for this scan.
      </Typography>
    </Stack>
  );
};
